<template>
  <div class="question-response-rank-order">
    <QuestionResponseBars
      :display-data="displayData"
      :assigned-colors="assignedColors"
      label="Points"
    />
  </div>
</template>


<script>
import QuestionResponseBars from './QuestionResponseBars.vue';

export default {
  name: 'QuestionResponseRankOrder',
  components: { QuestionResponseBars },
  props: ['question', 'assignedColors'],
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    choices() {
      return this.question.choices.map(choice => {
        if (typeof choice === 'string') return choice;
        return choice.text;
      });
    },
    max() {
      return this.choices.length;
    },
    scored() {
      if (!this.question.responses || !this.question.responses.length) {
        return [];
      }
      return this.question.responses.map(r => {
        const res = { name: r.name, response: [] };

        for (let i = 0; i < r.response.length; i++) {
          const text = r.response[i];
          res.response.push({ text, score: this.max - i });
        }
        return res;
      });
    },
    combined() {
      const data = {};

      this.scored.forEach(r => {
        r.response.forEach(choice => {
          const score = data[choice.text];
          data[choice.text] = (score ? score : 0) + choice.score;
        });
      });
      return data;
    },
    highScore() {
      let high = 0;

      this.choices.forEach(c => {
        const score = this.combined[c];
        if (score && score > high) high = score;
      });
      return high;
    },
    displayData() {
      return this.choices.map(choice => {
        let pts = this.combined[choice];
        if (!pts) pts = 0;
        const pct = this.highScore > 0 ? (100 * (pts / this.highScore)) : 0;
        return { choice, pct, label: pts + '' };
      });
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>
